/**
 * Centralized geolocation hooks with feature toggles
 *
 * To use the optimized version:
 * import { useGeoLocation } from 'hooks/useGeoLocation';
 *
 * To force the original version:
 * import { useGeoLocationOriginal as useGeoLocation } from 'hooks/useGeoLocation';
 */
import { geoCache } from 'context/GeoLocationContext/cache';
import { GEO_FEATURE_FLAGS } from 'context/GeoLocationContext/config';
import { useGeoLocationEnhanced } from './useGeoLocationEnhanced';
import { useGeoLocation as useGeoLocationOriginal } from '../useGeoLocationOriginal';

// Master switch - set to false to use original implementation everywhere
const USE_ENHANCED_VERSION = true;

// Export the appropriate version based on the master switch
// export const useGeoLocation = USE_ENHANCED_VERSION ? useGeoLocationEnhanced : useGeoLocationOriginal;
export const useGeoLocation = useGeoLocationEnhanced;

// Always export both versions for testing
export { useGeoLocationEnhanced, useGeoLocationOriginal };

// Export configuration and utilities

export { locationStorage } from 'context/GeoLocationContext/locationStorage';

// Debug utilities
export const getGeoDebugInfo = () => {
  if (!GEO_FEATURE_FLAGS.DEBUG_MODE) {
    return null;
  }

  return {
    version: USE_ENHANCED_VERSION ? 'enhanced' : 'original',
    features: GEO_FEATURE_FLAGS,
    cache: {
      stats: (window as any).geoCache?.getStats() || {},
    },
    storage: {
      hasStoredLocation: !!localStorage.getItem('bounce_location_data'),
      hasSessionLocation: !!sessionStorage.getItem('bounce_session_location'),
    },
  };
};

// Log configuration on load in development
if (typeof window !== 'undefined' && GEO_FEATURE_FLAGS.DEBUG_MODE) {
  console.log('[GeoLocation] Configuration:', {
    version: USE_ENHANCED_VERSION ? 'enhanced' : 'original',
    features: Object.entries(GEO_FEATURE_FLAGS)
      .filter(([_, enabled]) => enabled)
      .map(([feature]) => feature),
  });
}
